import API from "../../apiconfig";
import { logEvent, eventTypes } from "../../gtag";
import { Phases } from "../../home/constants";

const phase = {
  0: ["v2", "/PHASE_3"],
  1: ["v2", "/PHASE_2"],
  2: ["", ""],
};

export const simpleAction = () => (dispatch) => {
  dispatch({
    type: "SIMPLE_ACTION",
    payload: "result_of_simple_action",
  });
};

export const setCurrentPhase = (currentPhase, resetQuestion = false) => (
  dispatch
) => {
  dispatch({
    type: "SET_CURRENT_PHASE",
    payload: currentPhase,
    resetQuestion: resetQuestion,
  });
};

export const setCurrentTab = (tab, resetQuestion = false) => (dispatch) => {
  dispatch({
    type: "SET_CURRENT_TAB",
    payload: tab,
    resetQuestion: resetQuestion,
  });
};

export const setActiveQuestion = (id) => (dispatch) => {
  dispatch({
    type: "SET_ACTIVE_QUESTION",
    payload: id,
  });
};

export const removeFilters = (data) => (dispatch) => {
  dispatch({
    type: "REMOVE_FILTERS",
    payload: data,
  });
};

export const setFilters = (data) => (dispatch) => {
  dispatch({
    type: "SET_FILTERS",
    payload: data,
  });
};
export const getFilterQuestions = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(phase[currentPhase][0] + "/filters/" + phase[currentPhase][1].slice(1), formatFilters(filters))
      .then((res) => {
        dispatch(
          setFilterQuestions(
            // res.data
            res.data.filter((d) => d.label !== "Filter by state")
          )
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getPieData = (dispatch, currentPhase) => {
  return (dispatch) => {
    API.get(phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/AboutSurvey/Facilities")
      .then((res) => {
        dispatch(setPieData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};
export const formatFilters = (filters) => {
  const newfilters = [];
  Object.keys(filters).map((name) =>
    newfilters.push({ keys: name.split("-"), values: [filters[name]] })
  );
  return newfilters;
};

export const logFilterEvent = (filters, currentPhase) => {
  logEvent(eventTypes.filter, {
    event_category: "Filter selection",
    event_phase: currentPhase === 2 ? Phases.fall20 : currentPhase === 1 ? Phases.spring21 : Phases.fall21,
    event_label: Object.keys(filters)
      .map((key) => key + "=" + filters[key])
      .join("&"),
  });
};

const logSubTab = (main, subtabId, currentPhase) => {
  var sub = "";
  switch (main) {
    case "Testing":
      switch (subtabId) {
        case 0:
          sub = "Overview";
          break;
        case 1:
          sub = "Viral";
          break;
        case 2:
          sub = "Antibodies";
          break;
        default:
          break;
      }
      break;
    case "ContactTracing":
      switch (subtabId) {
        case 0:
          sub = "Overview";
          break;
        case 1:
          sub = "Providers";
          break;
        case 2:
          sub = "Protocols";
          break;
        default:
          break;
      }
      break;
    case "PandemicResponse":
      switch (subtabId) {
        case 0:
          sub = "Actions";
          break;
        case 1:
          sub = "RemoteWork";
          break;
        case 2:
          sub = "Coming Back";
          break;
        default:
          break;
      }
      break;
    default:
      break;
  }
  if (main && sub) {
    logEvent(eventTypes.click, {
      event_category: `${main} Subtab`,
      event_label: sub,
      event_phase: currentPhase === 2 ? Phases.fall20 : currentPhase === 2 ? Phases.spring21 : Phases.fall21,
    });
  }
};

export const getAboutSurveyData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/AboutSurvey/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setAboutSurveyData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getPandemicPreparednessData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/PandemicPreparedness/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setPandemicPreparednessData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getVaccinationData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/Vaccination/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setVaccinationData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getContactTracingData = (currentPhase, filters = []) => {
  return (dispatch) => {
    const formattedFilters = formatFilters(filters);
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/ContactTracing/Overview",
      formattedFilters
    )
      .then((res) => {
        dispatch(setContactTracingData(res.data, "Overview"));
        API.post(
          phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/ContactTracing/Protocols",
          formattedFilters
        ).then((res) => {
          dispatch(setContactTracingData(res.data, "Protocols"));
          API.post(
            phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/ContactTracing/Providers",
            formattedFilters
          ).then((res) => {
            dispatch(setContactTracingData(res.data, "Providers"));
          });
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getPandemicResponseData = (currentPhase, filters = []) => {
  return (dispatch) => {
    let formattedFilters = formatFilters(filters);
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/PandemicResponse/Adjustments",
      formattedFilters
    )
      .then((res) => {
        dispatch(setPandemicResponseData(res.data, "Adjustments"));
      })
      .catch((e) => {
        console.log(e);
      });

    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/PandemicResponse/ComeBack",
      formattedFilters
    )
      .then((res) => {
        dispatch(setPandemicResponseData(res.data, "ComeBack"));
      })
      .catch((e) => {
        console.log(e);
      });

    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/PandemicResponse/RemoteWork",
      formattedFilters
    )
      .then((res) => {
        dispatch(setPandemicResponseData(res.data, "RemoteWork"));
      })
      .catch((e) => {
        console.log(e);
      });

    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/PandemicPreparedness/All",
      formatFilters(filters)
    ).then((res) => {
      dispatch(setPandemicPreparednessData(res.data));
    });
  };
};

export const getTestingData = (currentPhase, filters = []) => {
  return (dispatch) => {
    let formattedFilters = formatFilters(filters);
    API.post(phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/Testing/Overview", formattedFilters)
      .then((res) => {
        dispatch(setTestingData(res.data, "Overview"));
      })
      .catch((e) => {
        console.log(e);
      });
    API.post(phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/Testing/Viral", formattedFilters)
      .then((res) => {
        dispatch(setTestingData(res.data, "Viral"));
      })
      .catch((e) => {
        console.log(e);
      });
    API.post(phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/Testing/Antibody", formattedFilters)
      .then((res) => {
        dispatch(setTestingData(res.data, "Antibody"));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getFutureOfWorkData = (currentPhase, filters = []) => {
  let dataURL = {
    0 : "/FutureOfWork",
    1 : "/PandemicResponse",
    2 : "/PandemicResponse",
  };
  return (dispatch) => {
    let formattedFilters = formatFilters(filters);
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/FutureOfWork/Overview",
      formattedFilters
    )
      .then((res) => {
        dispatch(setFutureOfWorkData(res.data, "Overview"));
      })
      .catch((e) => {
        console.log(e);
      });
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/FutureOfWork/Challenges",
      formattedFilters
    )
      .then((res) => {
        dispatch(setFutureOfWorkData(res.data, "Challenges"));
      })
      .catch((e) => {
        console.log(e);
      });
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + dataURL[currentPhase] + "/ComeBack",
      formattedFilters
    )
      .then((res) => {
        dispatch(setFutureOfWorkData(res.data, "ComeBack"));
      })
      .catch((e) => {
        console.log(e);
      });
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + dataURL[currentPhase] + "/RemoteWork",
      formattedFilters
    )
      .then((res) => {
        dispatch(setFutureOfWorkData(res.data, "RemoteWork"));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getFacilitiesSafetyData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/FacilitySafeties/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setFacilitiesSafetyData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getFinancialImpactData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/FinancialImpact/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setFinancialImpactData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const getWellBeingData = (currentPhase, filters = []) => {
  return (dispatch) => {
    API.post(
      phase[currentPhase][0] + "/charts" + phase[currentPhase][1] + "/WellBeing/All",
      formatFilters(filters)
    )
      .then((res) => {
        dispatch(setWellBeingData(res.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const setFinancialImpactData = (data) => {
  return {
    type: "SET_FINANCIAL_IMPACT_DATA",
    payload: data,
  };
};

export const setPieData = (data) => {
  return {
    type: "SET_PIE_DATA",
    payload: data,
  };
};

export const setAboutSurveyData = (data) => {
  return {
    type: "SET_ABOUT_SURVEY_DATA",
    payload: data,
  };
};

export const setVaccinationData = (data) => {
  return {
    type: "SET_VACCINATION_DATA",
    payload: data,
  };
};

export const setWellBeingData = (data) => {
  return {
    type: "SET_WELL_BEING_DATA",
    payload: data,
  };
};

export const setPandemicPreparednessData = (data) => {
  return {
    type: "SET_PANDEMIC_PREPAREDNESS_DATA",
    payload: data,
  };
};
export const setFacilitiesSafetyData = (data) => {
  return {
    type: "SET_FACILITIES_SAFETY_DATA",
    payload: data,
  };
};

export const setTestingData = (data, subTab) => {
  if (subTab === "Overview") {
    return {
      type: "SET_OVERVIEW_DATA",
      payload: data,
    };
  } else if (subTab === "Viral") {
    return {
      type: "SET_VIRAL_DATA",
      payload: data,
    };
  } else if (subTab === "Antibody") {
    return {
      type: "SET_ANTIBODY_DATA",
      payload: data,
    };
  }
};

export const setFutureOfWorkData = (data, subTab) => {
  if (subTab === "Overview") {
    return {
      type: "SET_FUTUREWORK_OVERVIEW_DATA",
      payload: data,
    };
  } else if (subTab === "Challenges") {
    return {
      type: "SET_CHALLENGES_DATA",
      payload: data,
    };
  } else if (subTab === "ComeBack") {
    return {
      type: "SET_FUTUREWORK_COMEBACK_DATA",
      payload: data,
    };
  } else if (subTab === "RemoteWork") {
    return {
      type: "SET_FUTUREWORK_REMOTEWORK_DATA",
      payload: data,
    };
  }
};

export const removeAllFilters = () => (dispatch) => {
  dispatch({
    type: "REMOVE_ALL_FILTERS",
  });
};

export const setTestingSubtab = (newValue, currentPhase, resetQuestion = false) => (
  dispatch
) => {
  dispatch({
    type: "SET_TESTING_SUBTAB",
    payload: newValue,
    resetQuestion: resetQuestion,
  });
  if (resetQuestion) {
    logSubTab("Testing", newValue, currentPhase);
  }
};

export const setFutureOfWorkSubtab = (newValue, currentPhase, resetQuestion = false) => (
  dispatch
) => {
  dispatch({
    type: "SET_FUTUREWORK_SUBTAB",
    payload: newValue,
    resetQuestion: resetQuestion,
  });
  if (resetQuestion) {
    logSubTab("FutureOfWork", newValue, currentPhase);
  }
};

export const setContractTracingSubtab = (newValue, currentPhase, resetQuestion = false) => (
  dispatch
) => {
  dispatch({
    type: "SET_CONTACT_TRACING_SUBTAB",
    payload: newValue,
    resetQuestion: resetQuestion,
  });
  if (resetQuestion) {
    logSubTab("ContactTracing", newValue, currentPhase);
  }
};

export const setPandemicResponseSubtab = (newValue, currentPhase, resetQuestion = false) => (
  dispatch
) => {
  dispatch({
    type: "SET_PANDEMIC_RESPONSE_SUBTAB",
    payload: newValue,
    resetQuestion: resetQuestion,
  });
  if (resetQuestion) {
    logSubTab("PandemicResponse", newValue, currentPhase);
  }
};

export const setContactTracingData = (data, subTab) => {
  if (subTab === "Overview") {
    return {
      type: "SET_CONTACTTRACING_OVERVIEW_DATA",
      payload: data,
    };
  } else if (subTab === "Protocols") {
    return {
      type: "SET_CONTACTTRACING_PROTOCOLS_DATA",
      payload: data,
    };
  } else if (subTab === "Providers") {
    return {
      type: "SET_CONTACTTRACING_PROVIDERS_DATA",
      payload: data,
    };
  }
};

export const setPandemicResponseData = (data, subTab) => {
  if (subTab === "ComeBack") {
    return {
      type: "SET_COMEBACK_DATA",
      payload: data,
    };
  } else if (subTab === "Adjustments") {
    return {
      type: "SET_ADJUSTMENTS_DATA",
      payload: data,
    };
  } else if (subTab === "RemoteWork") {
    return {
      type: "SET_REMOTEWORK_DATA",
      payload: data,
    };
  }
};

export const setFilterQuestions = (data) => {
  return {
    type: "SET_FILTER_QUESTIONS",
    payload: data,
  };
};
